<template lang="pug">
table.vue-invites-onboarding-status-table.table
  thead
    tr
      td Member email
      td Created account
      td Downloaded app
      td Tracked time
      td
        span Send reminder
        i.hi.hi-info.hi-14.ml-5(
          v-ntooltip="true"
          title="This will send an email reminder to encourage your team member to complete their next step"
        )
  tbody(v-if="loading")
    .curtain
      .spinner-wrapper
        span.hi.hi-spinner.hi-32.text-blue
  tbody(v-else-if="hasNoInvites()")
    tr
      td(colspan="5") Currently there are no invites
  tbody(v-else)
    tr.invite(
      v-for="invite in invites"
      :key="invite.email"
    )
      td.email
        span.pr-5
          | {{ invite.email }}
        i.hi.hi-info.hi-14(
          v-if="!invite.has_projects"
          v-ntooltip="true"
          title="This member has not been added to any projects. Add them to a project so they can track time."
        )
      td
        i.hi.hi-16(:class="{ 'hi-check': invite.accepted, 'hi-close': !invite.accepted }")
      td
        i.hi.hi-16(:class="{ 'hi-check': invite.has_downloaded_client, 'hi-close': !invite.has_downloaded_client }")
      td
        i.hi.hi-16(:class="{ 'hi-check': invite.has_client_activity, 'hi-close': !invite.has_client_activity }")
      td
        .btn.btn-icon.btn-naked.email-btn(
          v-ntooltip="{ placement: 'top', html: true }"
          :title="sendEmailTooltip(invite)"
          :disabled="disabledSendEmail(invite) ? 'disabled' : null"
          @click="sendEmail(invite)"
        )
          i.hi.hi-16.hi-paper-plane
    tr(v-if="isLoadingMore")
      td.centered(colspan="5")
        .spinner-wrapper
          span.hi.hi-spinner.hi-32.text-blue
</template>

<script>
import api from '../../api';

export default {
  name: 'InvitesOnboardingStatusTable',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    invites: {
      type: Array,
      required: true,
    },
    organizationId: {
      type: Number,
      required: true,
    },
    isLoadingMore: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    hasNoInvites() {
      return this.invites.length === 0;
    },
    sendEmail(invite) {
      if (!this.disabledSendEmail(invite)) {
        const success = (response) => {
          this.$appMessage(response.alert);
        };
        const onboardingEmailUrl = `/organizations/${this.organizationId}/invites/send_onboarding_email`;

        api.post(onboardingEmailUrl, { email: invite.email }).then(success, this.error);
      }
    },
    error() {
      this.$appMessage('Something went wrong. Please try again.');
    },
    sendEmailTooltip(invite) {
      if (this.isComplete(invite)) {
        return this.isComplete(invite);
      }
      if (this.inviteDisabled(invite)) {
        return `You cannot invite new members. You are at your plan's limit. Update it <a href="/organizations/${this.organizationId}/settings/billing">here</a>.`;
      }
    },
    disabledSendEmail(invite) {
      return this.inviteDisabled(invite) || this.isComplete(invite);
    },
    inviteDisabled(invite) {
      return !invite.accepted && !invite.has_available_invites;
    },
    isComplete(invite) {
      return invite.accepted && invite.has_downloaded_client && invite.has_client_activity
        ? 'All steps have been completed'
        : false;
    },
  },
};
</script>

<style scoped>
.centered {
  text-align: center;
}

.vue-invites-onboarding-status-table.table {
  min-height: 85px;
}
</style>
